import { render, staticRenderFns } from "./BLBreadcrumb.vue?vue&type=template&id=0af4bc05&scoped=true&lang=html&"
import script from "./BLBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./BLBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./BLBreadcrumb.vue?vue&type=style&index=0&id=0af4bc05&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4bc05",
  null
  
)

export default component.exports